export default {
	computed: {
		conceptTotal() {
			const t = {};

			Object.keys(this.fields.Conceptos).forEach((key) => {
				const c = this.fields.Conceptos[key];

				let total = 0;
				if (c.Precio && c.Cantidad) {
					total = (c.Precio * c.Cantidad);
					const descuento = c.Descuento ? ((total * c.Descuento) / 100) : 0;
					total -= descuento;
				}

				t[key] = parseFloat(total.toFixed(2));
			});

			return t;
		}
	},
	methods: {
		createConcept() {
			this.fields.Conceptos.push({
				Cantidad: 1,
				Concepto: '',
				Producto: null,
				Precio: 0,
				Descuento: 0
			});
		},
		removeConcept(index) {
			this.fields.Conceptos.splice(index, 1);
		}
	}
};
